<template>
  <navBack></navBack>
  <div class="page">
    <div class="topBox">
      <div class="secondBar">
        <div class="sheetInfo">
          <t-button @click="choseDate(0)" size="extra-small" variant="text">{{ startDate }}</t-button>
          <t-icon name="arrow-down" color="gray" />
          <text class="txtSpan">至</text>
          <t-button @click="choseDate(1)" size="extra-small" variant="text">{{ endDate }}</t-button>
          <t-icon name="arrow-down" color="gray" />
        </div>

        <div class="sheetInfo2">
          <t-button theme="primary" size="extra-small" v-if="customerId" @click="doAddNewFollow">
            新增
          </t-button>
        </div>
      </div>
    </div>

    <div class="listBox">
      <block v-for="(item, index) in dataList" :key="index">
        <div class="logItem" @click="doShowFollow(index)">
          <div class="leftSection">
            <div class="title">
              {{ item.CONTENT.length > 15 ? item.CONTENT.substring(0, 15) + '...' : item.CONTENT }}
            </div>
            <div class="time">{{ item.createAt.time3 }}</div>
          </div>
          <div class="rightSection">
            <div class="currentAmount">{{ item.userInfo.name }}</div>
          </div>
        </div>
      </block>

      <t-empty v-if="dataList.length === 0" description="没有记录" />
    </div>
  </div>

  <!-- 日期选择弹窗 -->
  <t-popup v-model:visible="showDatePicker" placement="bottom">
    <t-date-time-picker v-model="editDate" mode="date" title="选择时间" format="YYYY-MM-DD" @confirm="onDateConfirm"
      @cancel="showDatePicker = false" />
  </t-popup>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import { Toast } from 'tdesign-mobile-vue'
import navBack from '@/components/nav-back.vue'
const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase
const auth = proxy.$auth

// 路由实例
const route = useRoute()
const router = useRouter()

// 响应式数据
const startDate = ref(dayjs().subtract(12, 'month').format('YYYY-MM-DD'))
const endDate = ref(dayjs().format('YYYY-MM-DD'))
const dataList = ref([])
const customerId = ref('')
const pageIndex = ref(1)
const isOver = ref(false)
const editDateType = ref(0);
const showDatePicker = ref(false);
const editDate = ref(dayjs().format('YYYY-MM-DD'))



// 新增关注
const doAddNewFollow = () => {
  // 跳转到新增关注页面
  router.push({
    path: '/followAdd',
    query: { id: customerId.value }
  })
}

// 查看关注详情
const doShowFollow = (index) => {
  const item = dataList.value[index]
  console.log('查看关注详情，索引:', index, '数据:', item)
  // 实现跳转逻辑
  router.push({
    path: '/followDetail',
    query: { id: item._id }
  })
}
const choseDate = (type) => {
  showDatePicker.value = true
  editDateType.value = type
  editDate.value = type === 0 ? startDate.value : endDate.value
}

// 加载数据
const loadData = async () => {
  if (isOver.value) {
    Toast('没有更多')
    return
  }

  try {
    await auth.signInAnonymously()
    const db = app.database()

    const _ = db.command
    let queryData = {}

    if (customerId.value) {
      queryData['customerId'] = customerId.value
    }

    queryData['createAt.time3'] = _.and(_.gte(startDate.value), _.lte(endDate.value))

    const _pageSize = 20
    const _skipNum = Math.floor((pageIndex.value - 1) * _pageSize)
    const res = await db.collection("my_follow")
      .where(queryData)
      .orderBy('createAt.timeStamp', 'desc')
      .skip(_skipNum)
      .limit(_pageSize)
      .get()

    if (res.data.length < _pageSize) {
      isOver.value = true
    }
    pageIndex.value++
    dataList.value = [...dataList.value, ...res.data]
  } catch (error) {
    console.error('加载数据失败:', error)
    Toast('加载失败')
  }
}

// 组件挂载时加载数据
onMounted(() => {
  customerId.value = route.query.id
  loadData()
})
</script>

<style scoped>
.page {

  min-height: 100vh;
}

.topBox {
  height: 6vw;
  width: 100vw;
  box-sizing: border-box;
  padding: 0 2vw;
  margin-bottom: 5vw;
}

.secondBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sheetInfo {
  display: flex;
  align-items: center;
 
}

.sheetInfo2 {
  display: flex;
  align-items: center;
}

.picker {
  margin-right: 10px;
}

.txtSpan {
  margin: 0 10px;
}

.listBox {
  padding: 0 20px;
}

.logItem {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0 2rpx 10rpx rgba(0, 0, 0, 0.05);
}

.leftSection {
  flex: 1;
}

.title {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  word-break: break-all;
}

.time {
  font-size: 24px;
  color: #999;
}

.rightSection {
  text-align: right;
  min-width: 120px;
}

.currentAmount {
  font-size: 24px;
  color: #666;
}
</style>